"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtistBioFragmentContainer = exports.ArtistBio = exports.MAX_CHARS = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var _palette = require("@artsy/palette");

var _react = _interopRequireDefault(require("react"));

var _reactRelay = require("react-relay");

var _Responsive = require("../../Utils/Responsive");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MAX_CHARS = {
  xs: 100,
  default: 320
};
exports.MAX_CHARS = MAX_CHARS;

var ArtistBio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ArtistBio, _React$Component);

  function ArtistBio() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ArtistBio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ArtistBio)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderReadMore", function (size) {
      return _react.default.createElement(_palette.ReadMore, {
        onReadMoreClicked: _this.props.onReadMoreClicked,
        maxChars: size === "xs" ? MAX_CHARS.xs : MAX_CHARS.default,
        content: _this.props.bio.biography_blurb.text
      });
    });

    return _this;
  }

  _createClass(ArtistBio, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_palette.Serif, {
        size: "3"
      }, _react.default.createElement(_Responsive.Media, {
        at: "xs"
      }, this.renderReadMore("xs")), _react.default.createElement(_Responsive.Media, {
        greaterThan: "xs"
      }, this.renderReadMore("rest")));
    }
  }]);

  return ArtistBio;
}(_react.default.Component);

exports.ArtistBio = ArtistBio;
var ArtistBioFragmentContainer = (0, _reactRelay.createFragmentContainer)(ArtistBio, {
  bio: function bio() {
    var node = require("../../__generated__/ArtistBio_bio.graphql");

    if (node.hash && node.hash !== "7f29aeb3dc2e2e1aea12bc09ede0391b") {
      console.error("The definition of 'ArtistBio_bio' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data.");
    }

    return require("../../__generated__/ArtistBio_bio.graphql");
  }
});
exports.ArtistBioFragmentContainer = ArtistBioFragmentContainer;
//# sourceMappingURL=ArtistBio.js.map